<template>

    <div class="hamburger" :class="{ '--open': isOpen }">

        <span/>
        <span/>
        <span/>
        <span/>

    </div>

</template>

<script lang="ts">

    import { defineComponent } from 'vue'

    export default defineComponent({
        name: 'Hamburger',
        props: {
            isOpen: {
                type: Boolean, default: false
            }
        }
    })

</script>

<style lang="scss">

    @include component(hamburger) {

        position: relative;
        width: 14px;
        height: 12px;
        transform: rotate(0deg);
        transition: .5s ease-in-out;

        span {

            position: absolute;
            left: 0;
            display: block;
            width: 14px;
            height: 2px;
            transform: rotate(0deg);
            opacity: 1;
            transition: .25s ease-in-out;

            @include option(open) {

                background: white;

            }

            &:nth-child(1) {

                top: 0;

                @include option(open) {

                    top: 5px;
                    left: 50%;
                    width: 0%;

                }

            }

            &:nth-child(2) {

                top: 5px;

                @include option(open) {

                    transform: rotate(45deg);

                }

            }

            &:nth-child(3) {

                top: 5px;

                @include option(open) {

                    transform: rotate(-45deg);

                }

            }

            &:nth-child(4) {

                top: 10px;
                left: 5px;
                width: 9px;

                @include option(open) {

                    top: 5px;
                    left: 50%;
                    width: 0%;

                }

            }

        }

    }

</style>
